module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3lhE5"))).then(() => parcelRequire('d0iPb'));